import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const ChangeEditionClearRestrictionsForFreeMutation: GraphQLTaggedNode = graphql`
	mutation ChangeEditionClearRestrictionsForFreeMutation($contentId: ID!) {
		clearRestrictionsForFree(contentId: $contentId) {
			restrictionsHash
		}
	}
`;
